import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import AdvancedAdminControlsRecommendationsQuery from '@atlassian/jira-relay/src/__generated__/AdvancedAdminControlsRecommendationsQuery.graphql.ts';
import AdvancedAdminControlsLayoutQuery from '@atlassian/jira-relay/src/__generated__/AdvancedAdminControlsLayoutQuery.graphql.ts';

export const advancedAdminControlsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-advanced-admin-controls-entrypoint" */ './src/index.tsx'),
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => ({
		queries: {
			advancedAdminControlsRecommendationsQuery: {
				parameters: AdvancedAdminControlsRecommendationsQuery,
				variables: {
					context: {
						useCase: 'jiraAdvancedAdminControlsRerank',
						tenantId: tenantContext.cloudId,
						product: 'jira',
					},
					first: 10,
				},
			},
			advancedAdminControlsLayoutQuery: {
				parameters: AdvancedAdminControlsLayoutQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					hamsProductKey: 'jira-software.ondemand',
					offeringKey: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
				},
			},
		},
	}),
});
